import { useEffect, useMemo, useState } from 'react'
import { MembersNotInDms, Observable } from '@towns-protocol/sdk'
import { useObservable, useTownsContext } from 'use-towns-client'

const READY_TIMEOUT = 3_000

type MemberNotInDMsChannelMenuItem = {
    type: 'memberNotInDMs'
    id: string
}

const EMPTY_MEMBERS_NOT_IN_DMs = new Observable<MembersNotInDms>({
    members: [],
})

export function useMembersNotInDMs(spaceId: string): {
    data: MemberNotInDMsChannelMenuItem[]
    isLoading: boolean
} {
    const [ready, setReady] = useState(false)
    const casablancaClient = useTownsContext().casablancaClient
    const observable = useMemo(() => {
        return casablancaClient?.streamsView.membersNotInDms(spaceId) ?? EMPTY_MEMBERS_NOT_IN_DMs
    }, [casablancaClient, spaceId])

    const data = useObservable(observable)

    const transformed = useMemo(() => {
        return data.members.map((member) => ({
            type: 'memberNotInDMs' as const,
            id: member.id,
        }))
    }, [data])

    useEffect(() => {
        let mounted = true

        const timeoutId = setTimeout(() => {
            if (mounted) {
                setReady(true)
            }
        }, READY_TIMEOUT)

        return () => {
            mounted = false
            clearTimeout(timeoutId)
        }
    }, [casablancaClient])

    return {
        data: transformed,
        isLoading: !ready && data.members.length === 0,
    }
}
